import { render } from "./InvoiceExamine.vue?vue&type=template&id=10d7d101"
import script from "./InvoiceExamine.vue?vue&type=script&lang=js"
export * from "./InvoiceExamine.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__